// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"styles_bannerWrapper__slbvC","bannerLink":"styles_bannerLink__Pylmi","bannerImage":"styles_bannerImage__xWNgJ","logo":"styles_logo__Un_cK"};